import { useId, useRef } from 'react';

const tabClass = {
  active: '-mb-px border-b-2 border-primary-500 px-4 py-2.5 font-medium text-primary-500',
  inactive:
    '-mb-px border-b-2 border-transparent px-4 py-2.5 font-medium text-theme-secondarytextcolor hover:text-theme-headings dark:text-themedark-secondarytextcolor dark:hover:text-themedark-headings',
};

const keyOffsets = { ArrowRight: 1, ArrowLeft: -1 };

const Tabs = ({ tabs, value, onChange, ariaLabel, children, className = '' }) => {
  const baseId = useId();
  const tabRefs = useRef({});
  const tabId = (id) => `${baseId}-tab-${id}`;
  const panelId = (id) => `${baseId}-panel-${id}`;

  const select = (id) => {
    onChange(id);
    tabRefs.current[id]?.focus();
  };

  const handleKeyDown = (event) => {
    const index = tabs.findIndex((tab) => tab.id === value);
    let next = null;
    if (event.key in keyOffsets) next = (index + keyOffsets[event.key] + tabs.length) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;
    if (next === null) return;
    event.preventDefault();
    select(tabs[next].id);
  };

  return (
    <div className={className}>
      <div
        role="tablist"
        aria-label={ariaLabel}
        className="mb-4 flex flex-wrap border-b border-theme-border dark:border-themedark-border"
        onKeyDown={handleKeyDown}
      >
        {tabs.map((tab) => {
          const selected = tab.id === value;
          return (
            <button
              key={tab.id}
              ref={(node) => {
                tabRefs.current[tab.id] = node;
              }}
              type="button"
              role="tab"
              id={tabId(tab.id)}
              aria-selected={selected}
              aria-controls={selected ? panelId(tab.id) : undefined}
              tabIndex={selected ? 0 : -1}
              className={selected ? tabClass.active : tabClass.inactive}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      <div role="tabpanel" id={panelId(value)} aria-labelledby={tabId(value)} tabIndex={0}>
        {children}
      </div>
    </div>
  );
};

export default Tabs;
